import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import PlaybookPlayFinder from "./components/playbook-play-finder/playbook-play-finder";
import { PlaybookSelector } from "./components/playbook-selector/playbook-selector";
import { PlaybookViewer } from "./components/playbook-viewer/playbook-viewer";
import { usePlaybookContextApi } from "./hooks/use-playbook-context";
import { PlaybookContext } from "./playbook-context";
import styles from "./playbook.page.module.scss";

export const Playbooks = () => {
  const playbookContextApi = usePlaybookContextApi();

  return (
    <DndProvider backend={HTML5Backend}>
      <PlaybookContext.Provider value={playbookContextApi}>
        <div className={styles.playbooksPageContainer}>
          <PlaybookPlayFinder />
          <PlaybookSelector />
          <PlaybookViewer />
        </div>
      </PlaybookContext.Provider>
    </DndProvider>
  );
};
